import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button } from "@ts-digital/vrc";
import { FormattedMessage } from "react-intl";

class ButtonInputUpload extends Component {
  static propTypes = {
    handleUpload: PropTypes.func,
    disabled: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {};
    this.hiddenInput = React.createRef();
  }

  render() {
    return (
      <span>
        <input
          ref={this.hiddenInput}
          type="file"
          name="filesMultiple"
          id="fileUpload"
          className="box__file"
          aria-label="Carica documenti"
          multiple
          onChange={this.props.handleUpload}
          onClick={event =>
            /** serve ad gestire una pulizia e conseguente caricamento dello stesso file */
            (event.target.value = "")
          }
        />{" "}
        <label
          htmlFor="fileUpload"
          onClick={e => {
            if (!this.props.disabled){
              this.hiddenInput.current.click();
            }
          }}
        >
          <Button
            kind="secondary"
            colorScheme={"ghost"}
            style={{ margin: "16px", padding: "0 83px" }}
          >
            <FormattedMessage id="upload.widget.button" />
          </Button>
        </label>
      </span>
    );
  }
}

export default ButtonInputUpload;
